module.exports = __webpack_public_path__ + "assets/img/icon1-menu.66ea247c.svg";